<template>
	<a-modal v-model="show" :title="`添加${type}`" :width="400" @ok="doSubmit" @cancel="_close" centered destroyOnClose>
		<a-form-model v-if="isfile" ref="formRef" :model="formData" :rules="formRule">
			<a-row :gutter="15">
				<a-col span="24">
					<a-form-model-item label-position="top" prop="name">
						<a-input v-model="formData.name" placeholder="请输入文件夹名称"></a-input>
					</a-form-model-item>
				</a-col>
			</a-row>
		</a-form-model>
		<a-form-model v-else>
			<a-row :gutter="15">
				<a-col span="24">
					<a-form-model-item label-position="top" prop="name">
						<upfile ref="upfile" url="/scope/profile/upload" :fileId="fileData.fileId"></upfile>
					</a-form-model-item>
				</a-col>
			</a-row>
		</a-form-model>
	</a-modal>
</template>

<script>
import utils from '@/common/utils';
import apiUtil from '@/common/apiUtil';
import upfile from '@/views/space/components/upFile.vue';
export default {
	components: { upfile },
	data() {
		return {
			isfile: true,
			show: false,
			loading: false,
			organList: apiUtil.getOrganList(),
			staffList: [],
			formData: {
				name: '',
				parentId: ''
			},
			file: '',
			type: '',
			// 上传文件的表单
			fileData: {
				file: null,
				fileId: ''
			},
			formRule: {
				name: [{ required: true, message: '请输入文件夹名称' }]
			}
		};
	},
	methods: {
		...apiUtil,
		_show(fileId, type) {
			this.show = true;
			this.type = type;
			this.formData.name = '';
			this.fileData.name = '';
			if (type == '文件') {
				this.isfile = false;
			} else if (type == '文件夹') {
				this.isfile = true;
			}
			this.$nextTick(() => {
				if (fileId) {
					this.formData.parentId = fileId;
					this.fileData.fileId = fileId;
				} else {
					this.formData.parentId = 0;
					this.formData.name = '';
				}
			});
		},

		_close() {
			// this.$refs.formRef.resetFields();
			this.show = false;
			this.formData.name = '';
			this.fileData.name = '';
		},
		upload(e) {
			console.log(e);
		},
		doSubmit() {
			utils.showSpin();
			if (this.type == '文件夹') {
				this.http.post('/platform/scope/profile/create-folder', this.formData).then(ret => {
					if (ret.code == 200) {
						utils.success('操作成功！').then(() => {
							this.$emit('success');
							this.show = false;
						});
						this.show = false;
					}
				});
			}
			if (this.type == '文件') {
				this.$refs.upfile.handleUpload().then(ret => {
					this.show = false;
					if (ret.code == 200) {
						utils.success('操作成功！').then(() => {
							// this.show = false;
							this.$emit('success');
						});
					}
				});
			}
		}
	}
};
</script>

<style scoped></style>
